import { DepositIcon } from "@xola/icons";
import React from "react";
import { Audit, Gratuity, GratuityObject, PaymentLineItem, Purchase, PurchaseItem } from "types";
import { TimelineItem } from "../TimelineItem";
import PaymentTimelineItemContent from "./PaymentTimelineItemContent";

interface GratuityTimelineItemProps {
    showDate?: boolean;
    change: Gratuity;
}

export const GratuityTimelineItem = ({ showDate = false, change: gratuity }: GratuityTimelineItemProps) => {
    if (!gratuity.transaction) {
        return null;
    }

    const { method, remoteTransactions } = gratuity.transaction;
    const card = remoteTransactions?.[0]?.cardSummary;
    return (
        <TimelineItem
            title="Gratuity Received"
            audit={gratuity}
            icon={<DepositIcon />}
            color="success"
            showDate={showDate}
            traveler={gratuity.traveler}
        >
            <PaymentTimelineItemContent
                amount={gratuity.amount}
                method={method}
                comment={gratuity.comment}
                card={card}
            />
        </TimelineItem>
    );
};

GratuityTimelineItem.supportsAudit = (
    _purchase: Purchase,
    _item: PurchaseItem,
    _audit: Audit,
    _lineItem: PaymentLineItem,
    _timezone: string,
    change?: Gratuity,
) => {
    return change?.object === GratuityObject;
};
